import { axiosClient } from "@/shared/api/axios-client";
import type { OrganizacionCatalogo, SolicitudDetalle } from "@/lib/types";

/**
 * P44 · FB60 Contrapago: no hay CFDI del que derivar la organización, así que
 * el solicitante la elige manualmente entre las que tiene permitidas.
 */
export const organizacionManualApi = {
  listarMisOrganizaciones: () =>
    axiosClient
      .get<OrganizacionCatalogo[]>("/api/catalogos/organizaciones")
      .then((r) => r.data),
  seleccionar: (solicitudId: string, organizacionId: string) =>
    axiosClient
      .patch<SolicitudDetalle>(`/api/solicitudes/${solicitudId}/organizacion-manual`, {
        organizacionId,
      })
      .then((r) => r.data),
};
